import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import Sidebar from './Sidebar'
import { buildApiUrl } from '../../config/api.config'

const Admin = ({showAlert}) => {
  const [userDetails, setUserDetails] = useState({ name: "", email: "", id: "" });
  const location = useLocation();

    const fetchUserDetails = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const urlToken = params.get('token');
        const urlRestaurantId = params.get('restaurantId');
        
        if (urlToken) localStorage.setItem('token', urlToken);
        if (urlRestaurantId) localStorage.setItem('currentRestaurantId', urlRestaurantId);

        const token = localStorage.getItem("token");
        if (!token) {
          return null;
        }
        const response = await fetch(buildApiUrl("/users/getuser"), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": token,
          },
        });
        if (response.ok) {
          const data = await response.json();
          // Persist full details to allow other components to use role/restaurantId
          localStorage.setItem("userDetails", JSON.stringify(data));
          return data;
        } else {
          return null;
        }
      } catch (error) {
        console.error("Error fetching user details:", error.message);
        return null;
      }
    };
  
    useEffect(() => {
      const getUserDetails = async () => {
        const userData = await fetchUserDetails();
        if (userData) setUserDetails(userData);
      };
  
      getUserDetails();
    }, [location.search]);
  return (
    <div className="admin-layout" style={{backgroundColor:"#1B1C1F"}}>
      <Sidebar showAlert={showAlert}/>
      <div style={{color:"white",width:"100%"}}>
        <h1 style={{textAlign:"center",marginTop:"17rem"}}>Welcome to Admin Panel</h1>
      </div>
    </div>
  )
}

export default Admin
